module.exports = __webpack_public_path__ + "img/flag_id.9c3315f5.svg";